var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",function(){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.iconColor}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]},null,{ on, attrs })]}}],null,true)},'v-tooltip',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }